import { defineStore } from 'pinia';
import { apiCreateOffer, getOfferStats } from '@/api/offers-common';
import type { CreateOfferPayload, Offer, OfferStats } from '@/offers/types/offer';

export const useOfferStore = defineStore('offer', {
  state: () => ({
    offer: {} as Offer,
    offerStats: {} as OfferStats,
  }),
  actions: {
    async createOffer(payload: CreateOfferPayload) {
      const { data } = await apiCreateOffer(payload);

      this.offer = data;
    },
    async getOfferStats() {
      const { data, error } = await getOfferStats();

      if (!error) {
        this.offerStats = data;
      } else {
        console.error('Failed to fetch offer status!', error);
      }
    },
  },
});
